import { Route } from 'types/route.type';
import ListOrderDistribution from './list-order-distribution';

export const routes: Route[] = [
  {
    path: '/order-feed/order-distribution/:siteErpId?/:globalSiteId?',
    component: ListOrderDistribution,
    id: 'orderFeed.navigation.orderDistribution',
  },
];
